// react
import { useContext, useState } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// types
import { Component, Pagination } from '../../../../../@types';

// router
import { useSearchParams } from 'react-router-dom';

// context
import { ContextProject } from '../../Project.context';

// hooks
import { useFetch } from '../../../../../hooks/useFetch';

// mui
import { Container, Grid, Paper, Typography } from '@mui/material';

// dialogs
import { DialogAddComponent } from '../../../../dialogs/DialogAddComponent/DialogAddComponent';

// tables
import { TableBasicComponents } from '../../../../tables/basic/TableBasicComponents/TableBasicComponents';

// utils
import { defaultPagination } from '../../../../../utils/defaults';

export const Components = () => {
	// session
	const accessToken = sessionStorage.getItem('accessToken');
	const idToken = sessionStorage.getItem('idToken');

	// hooks
	const [searchParams, setSearchParams] = useSearchParams();
	const { t } = useTranslation();

	// context
	const { project } = useContext(ContextProject);

	// params
	const paramPage = Number(searchParams.get('page') || 1);
	const paramDialog = searchParams.get('dialog');

	// state
	const [components, setComponents] = useState<Component[]>([]);
	const [pagination, setPagination] = useState<Pagination>({
		...defaultPagination,
		perPage: 5,
	});

	// fetch components
	const urlComponents = `${process.env.REACT_APP_API_URL}/components?project=${project?.id}&populate=allocations.loan,allocations.conversions,allocations.utilization,parent&page=${paramPage}&limit=${pagination.perPage}`;

	const { isLoading, refetch: refetchComponents } = useFetch({
		isEnabled: Boolean(project),
		url: urlComponents,
		options: {
			headers: {
				Authorization: `Bearer ${accessToken}`,
				User: String(idToken),
			},
		},
		onSuccess: (res) => {
			if (res.data) {
				setComponents(res.data);
			}

			if (res.pagination) {
				setPagination(res.pagination);
			}
		},
	});

	return (
		<Container maxWidth={false}>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Paper
						sx={(theme) => {
							return {
								padding: theme.spacing(2),
							};
						}}>
						<Grid container spacing={2}>
							<Grid item xs={12}>
								<Typography variant="h3">{t('components')}</Typography>
							</Grid>
							<Grid item xs={12}>
								<TableBasicComponents
									borderRadius={2}
									color="grey"
									data={components}
									hasBorder={true}
									hasDividers={true}
									isLoading={isLoading}
									refetchComponents={refetchComponents}
									TableFooterProps={{
										numShowing: components.length,
										pagination,
									}}
								/>
							</Grid>
						</Grid>
					</Paper>
				</Grid>
			</Grid>
			<DialogAddComponent
				isOpen={paramDialog === 'addComponent'}
				onClose={() => {
					searchParams.delete('dialog');
					setSearchParams(searchParams);
				}}
				onSuccess={() => {
					refetchComponents();
					searchParams.delete('dialog');
					setSearchParams(searchParams);
				}}
			/>
		</Container>
	);
};
